import { cr } from "fire-wind-water";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

Swiper.use([Autoplay, Navigation, Pagination]);

let SWIPER_LIST: { [label: string]: Swiper } = {};

// 创建轮播, 参数是组件数据数组，执行时机已经渲染完dom结构
export function initMimage(): void {
  destroyMimage();
  const doms: NodeListOf<HTMLElement> =
    document.querySelectorAll(".sk-j-mimage");
  cr.each(doms, (d) => {
    SWIPER_LIST[`${d.dataset.componentType}_${d.dataset.componentId}`] =
      new Swiper(d, {
        slidesPerView: "auto",
        spaceBetween: 3,
      });
  });
}

// 销毁轮播, res是组件id，传过来时按组件销毁，没有参数时，销毁所有
export function destroyMimage(res?: any): void {
  if (res) {
    const id: string | number = res.data.id;
    const type: string = res.data.type;
    if (SWIPER_LIST[`${type}_${id}`]) {
      SWIPER_LIST[`${type}_${id}`].destroy(true, true);
      delete SWIPER_LIST[`${type}_${id}`];
    }
  } else {
    cr.each(SWIPER_LIST, (d) => {
      if (d && d.el) {
        d.destroy(true, true);
      }
    });
    SWIPER_LIST = {};
  }
}
